/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Settings_WordsInputs */

const en_us2_search_settings_words = /** @type {(inputs: Search_Settings_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`profile settings preferences account`)
};

const pt_br2_search_settings_words = /** @type {(inputs: Search_Settings_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`perfil ajustes configuracoes conta`)
};

const es_419_search_settings_words = /** @type {(inputs: Search_Settings_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`perfil ajustes configuracion preferencias cuenta`)
};

const pt_pt2_search_settings_words = /** @type {(inputs: Search_Settings_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`perfil definicoes preferencias conta`)
};

const fr_fr2_search_settings_words = /** @type {(inputs: Search_Settings_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`profil reglages preferences parametres compte`)
};

const de_de2_search_settings_words = /** @type {(inputs: Search_Settings_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`profil einstellungen präferenzen konto`)
};

const it_it2_search_settings_words = /** @type {(inputs: Search_Settings_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`profilo impostazioni preferenze account`)
};

/**
* | output |
* | --- |
* | "profile settings preferences account" |
*
* @param {Search_Settings_WordsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_settings_words = /** @type {((inputs?: Search_Settings_WordsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Settings_WordsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_settings_words(inputs)
	if (locale === "es-419") return es_419_search_settings_words(inputs)
	if (locale === "pt-PT") return pt_pt2_search_settings_words(inputs)
	if (locale === "fr-FR") return fr_fr2_search_settings_words(inputs)
	if (locale === "de-DE") return de_de2_search_settings_words(inputs)
	if (locale === "it-IT") return it_it2_search_settings_words(inputs)
	return en_us2_search_settings_words(inputs)
});
export { search_settings_words as "search.settings_words" }